import React, { useState, useRef, useEffect, useCallback, useMemo, useLayoutEffect } from "react";
import { Resizable } from 'react-resizable';
import {
  Table,
  Input,
  Button,
  Space,
  Row,
  Col,
  Card,
  Breadcrumb,
  Badge,
  Select,
  Divider,
  Form,
  DatePicker,
  Dropdown,
  Menu,
  Modal,
  Flex,
  notification,
  Empty,
  Popconfirm,
  Popover,
  Alert,
  Progress,
  Tooltip,
  Spin
} from "antd";
import {
  PlusOutlined,
  HomeOutlined,
  SearchOutlined,
  EllipsisOutlined,
  DownOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import { Link, useOutletContext, useNavigate } from "react-router-dom";
import Create from "./Create";
import InvoiceGeneration from '../AccountReceivable/InvoiceGenerationSubmission';
import ShareDocument from '../AccountReceivable/ShareDocument';
import ViewDocument from '../AccountReceivable/View';
import StatusTrial from '../AccountReceivable/StatusTrial';
import { useSelector } from 'react-redux';
import moment from "moment";
import validationRules from '../../../../assets/validation/rules';
import validateForm from '../../../../utils/FormValidation';
import AccountReceivableAPI from "../../../../restAPI/AccountReceivableAPI";
import AccountPayableAPI from "../../../../restAPI/AccountPayableAPI"
import CompanyAPI from "../../../../restAPI/CompanyAPI";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import documentManagementAPI from '../../../../restAPI/DocumentManagement'
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'; // to compare date using day js
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'; // to compare date using day js
import { useNotificationContext } from '../../../../contexts/NotificationContext';

const popoverContentCla = (
  <div>
    Refer to link below
    to obtain the correct code:<br />
    <a href="https://sdk.myinvois.hasil.gov.my/codes
/classification-codes" target="_blank">https://sdk.myinvois.hasil.gov.my/codes
      /classification-codes</a><br />
    For Self-Billed Invoices, please use:<br />
    • 034 – Self-billed Import of Goods<br />
    • 035 – Self-billed Import of Services<br />
    • 036 – Self-billed Import (Others)
  </div>
);

const { Option } = Select;
const ResizableTitle = (props) => {
  const { onResize, width, children, ...restProps } = props;
  if (!width) return <th {...restProps}>{children}</th>;

  return (
    <th {...restProps}>
      <Resizable
        width={width}
        height={0}
        onResize={onResize}
        draggableOpts={{ enableUserSelectHack: false }}
        handle={
          <span
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              cursor: "col-resize",
              width: "2px",
              height: "100%",
              background: "#ffeb3b3b",
            }}
          />
        }
      >
        <div>{children}</div>
      </Resizable>
    </th>
  );
};

dayjs.extend(customParseFormat);
export default function UserTable() {
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const tableContainerRef = useRef();
  const dateFormat = 'YYYY/MM/DD';
  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchedColumn, setSearchedColumn] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [selectedRecordsUpdated, setSelectedRecordsUpdated] = useState([]);
  const [documentType, setDocumentType] = useState([]);       
  const [status, setStatus] = useState([]);
  const [classification, setclassification] = useState([]);
  const searchInput = useRef(null);
  const createRef = useRef(null);
  const invoiceRef = useRef(null);
  const shareDocumentRef = useRef(null);
  const viewDocumentRef = useRef(null);
  const statusTrialRef = useRef(null);
  const { token } = useSelector(state => state.auth);
  const [errors, setErrors] = useState({});
  const [payload, setPayload] = useState({
    "fromDate": dayjs(),
    "toDate": dayjs(),
    "documentType": [],
    "classification": [],
    "supplierName": "",
    "buyerName": [],
    "companyCode": [],
    "invoiceNumber": [],
    "status": [],
  });
  const [accountReceivableSearchData, setAccountReceivableSearchData] = useState([]);
  const formRef = useRef(null);
  const [isStatusTrialOpen, setIsStatusTrialOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountRecivableSearchData, setAccountRecivableSearchData] = useState([]); // to store the filterd list
  const [accountRecivableAllData, setAccountRecivableAllData] = useState([]);// to initially to store all the data comming from API
  const [companyCodeOptions, setCompanyCodeOptions] = useState([]); // to store unique company codes for dropdown
  const selectedinvoiceRef = useRef([]); // to stoe the selected invoices
  const [isPopconfirmVisible, setIsPopconfirmVisible] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelRemark, setCancelRemark] = useState("");
  const [cancelConfirmedRecords, setCancelConfirmedRecords] = useState({});
  const [isRecordSelected, setIsRecordSelected] = useState(false);
  const [isShareBtnDisable, setIsShareBtnDisable] = useState(false);
  const [isCancelBtnDisable, setIsCancelBtnDisable] = useState(false);
  const [cancelButtonDisabled, setCancelButtonDisabled] = useState(false);
  const [isSelectedRecordSubmittable, setIsSelectedRecordSubmittable] = useState(false);
  const [isDeleteBtnDisable, setIsDeleteBtnDisable] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(false);
  const [deleteButtonDisableReason, setDeleteButtonDisableReason] = useState('');
  const [companyData, setCompanyData] = useState(null);
  const [isLhdnSubmissionBlocked, setIsLhdnSubmissionBlocked] = useState(false);
  const [defaultLoadedDateRange, setDefaultLoadedDateRange] = useState({ startDate: null, endDate: null });
  const notificationShown = useRef(false);
  const hasUpdatedDatesRef = useRef(false);
  const [isdownloadBtnDisable, setIsdownloadBtnDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loadedCount, setLoadedCount] = useState(0);
  const [progress, setProgress] = useState(0);
  const lastProgressRef = useRef(0);
  const updateProgressTimeoutRef = useRef(null);
  const isLoadingRef = useRef(false); // Prevent duplicate API calls

  //useOutletContext is a React Router hook that allows a parent route to pass data down to the child route rendered inside <Outlet />.
  //You provide some context at the <Outlet context={someData} /> in the parent. Then, child pages receive that context via the useOutletContext() hook.

  const { groupId, companyId } = useOutletContext(); // Receive the context! passed in MainLayout.js file
  // Extend dayjs with the plugins
  //The extend() method in Day.js is used to enable a plugin (like isSameOrAfter) by adding it to the Day.js core.
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);

  // Initialize real-time notifications
  // Get userId from token or localStorage - need to decode token to get userId
  const getUserId = () => {
    console.log('Getting userId from token:', token);
    if (token) {
      try {
        // Decode JWT token to get userId
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('Decoded token payload:', payload);
        const userId = payload.userId || payload.id || payload.sub;
        console.log('Extracted userId from token:', userId);
        return userId;
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
    const localUserId = localStorage.getItem('userId');
    console.log('Using userId from localStorage:', localUserId);
    return localUserId;
  };
  
  const userId = getUserId();
  console.log('Final userId for notifications:', userId);
  const { setProcessingStatus } = useNotificationContext();

  const showSingleCancelModal = (record) => {
    let cancelRecords = [];
    cancelRecords.push(record);
    //Added new property to the selected state uploadDate: dayjs(rowValue.uploadedDateAndTime).format('YYYY-MM-DD HH:mm:ss'),
    let selectedListforCancel = cancelRecords.map(item => {
      return {
        ...item,
        cancellationStatus: item.status === "deleted" ? "Cancellation Completed" : (item.updatedDateAndTime ? dayjs().diff(dayjs(item.updatedDateAndTime), 'hour') <= 72 : dayjs().diff(dayjs(item.uploadDate), 'hour') <= 72) ? "Ready for Cancellation" : "Cancellation Expired"
      }
    });
    setSelectedRecords(selectedListforCancel);
    setIsModalVisible(true);
  };
  const [allDocumentTypes, setAllDocumentTypes] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  // Dynamic menu items based on selected records
  const getMenuItems = () => {
    const hasSuccessRecords = selectedRows.some(record => record.status === 'success');
    const hasAnyRecords = selectedRows.length > 0;

    return [
      // Excel export - always available for any selected records
      {
        label: "Excel",
        key: "1",
        icon: <FileExcelOutlined />,
        disabled: !hasAnyRecords,
        onClick: async () => {
          if (selectedRows.length === 0) {
            openNotificationWithIcon(
              "error",
              "No Records Selected",
              "Please select records to export.",
              "bottomLeft"
            );
            return;
          }

          // Define the headings for the Excel file
          const headings = [
            [
              "Key",
              "Document Mogu ID",
              "Invoice Number",
              "Document Type",
              "Trading Partner Classification",
              "Upload Date",
              "Uploaded By",
              "Supplier Name",
              "Buyer Name",
              "Status",
              "Original File Path",
              "Is Active",
              "Is Duplicate",
              "Is Tax Mismatch",
              "Is Required Trading Partner Company Code Missing",
              "TPS ID",
              "Total Tax Amount",
              "Total Payable Amount",
              "URL",
              "Validated Date And Time",
              "UUID"
            ],
          ];

          try {
            // Map the selectedRows data to match the headings
            const data = selectedRows.map((rowValue) => [
              rowValue.key || "",
              rowValue.documentMoguID || "",
              rowValue.invoiceNumber || "N/A",
              rowValue.documentType || "N/A",
              rowValue.classification || "N/A",
              rowValue.uploadDate || "N/A",
              rowValue.uploadedBy || "N/A",
              rowValue.supplierName || "N/A",
              rowValue.buyerName || "N/A",
              rowValue.status || "N/A",
              rowValue.originalFilePath || "N/A",
              rowValue.isActive || "",
              rowValue.isDuplicate || "",
              rowValue.isTaxMismatch || "",
              rowValue.isRequiredTPCompanyCodeMissing || "",
              rowValue.tPS_Id || "",
              rowValue.totalTaxAmount || "0",
              rowValue.totalPayableAmount || "",
              rowValue.url || "",
              rowValue.InvoiceDateTime || "N/A",
              rowValue.uuid || ""
            ]);

            // Combine headings and data
            const worksheetData = [...headings, ...data];

            // Create a worksheet
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

            // Create a workbook and append the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Records");

            // Generate and download the Excel file with timestamp
            const timestamp = new Date().toISOString().split('T')[0];
            const filename = `AccountReceivable_Records_${timestamp}.xlsx`;
            XLSX.writeFile(workbook, filename);

            openNotificationWithIcon(
              "success",
              "Excel Export Successful",
              `${selectedRows.length} records exported successfully.`,
              "bottomLeft"
            );
          } catch (error) {
            console.error("Error generating Excel file:", error);
            openNotificationWithIcon(
              "error",
              "Excel Generation Failed",
              "An error occurred while generating the Excel file.",
              "bottomLeft"
            );
          }
        },
      },
      // PDF export - only available for success status records
      {
        label: "PDF",
        key: "2",
        icon: <FilePdfOutlined />,
        disabled: !hasSuccessRecords,
        onClick: () => {
          if (!hasSuccessRecords) {
            openNotificationWithIcon(
              "error",
              "No Success Records Selected",
              "PDF download is only available for records with 'success' status.",
              "bottomLeft"
            );
            return;
          }
          handleBulkDownloadAndZip();
        },
      },
      // JSON export - only available for success status records
      {
        label: "JSON",
        key: "3",
        icon: <FilePdfOutlined />, // Replace with a JSON icon if available
        disabled: !hasSuccessRecords,
        onClick: async () => {
          if (!hasSuccessRecords) {
            openNotificationWithIcon(
              "error",
              "No Success Records Selected",
              "JSON download is only available for records with 'success' status.",
              "bottomLeft"
            );
            return;
          }

          try {
            // Filter only success records for JSON export
            const successRecords = selectedRows.filter(record => record.status === 'success');

            // Map the success records data to match the fields
            const jsonData = successRecords.map((rowValue) => ({
              Key: rowValue.key || "",
              "Document Mogu ID": rowValue.documentMoguID || "",
              "Uploaded User ID": rowValue.uploadedUserId || "",
              "Invoice Number": rowValue.invoiceNumber || "N/A",
              "Document Type": rowValue.documentType || "N/A",
              Classification: rowValue.classification || "N/A",
              "Upload Date": rowValue.uploadDate || "N/A",
              "Uploaded By": rowValue.uploadedBy || "N/A",
              "Supplier Name": rowValue.supplierName || "N/A",
              "Buyer Name": rowValue.buyerName || "N/A",
              Status: rowValue.status || "N/A",
              "Original File Path": rowValue.originalFilePath || "N/A",
              "Is Active": rowValue.isActive || "",
              "Is Duplicate": rowValue.isDuplicate || "",
              "Is Tax Mismatch": rowValue.isTaxMismatch || "",
              "Is Required Trading Partner Company Code Missing": rowValue.isRequiredTPCompanyCodeMissing || "",
              "TPS ID": rowValue.tPS_Id || "",
              "Total Tax Amount": rowValue.totalTaxAmount || "0",
              "Total Payable Amount": rowValue.totalPayableAmount || "",
              "URL": rowValue.url || "",
              "Validated Date And Time": rowValue.InvoiceDateTime || "",
              "UUID": rowValue.uuid || ""
            }));

            // Convert JSON data to a Blob
            const jsonBlob = new Blob([JSON.stringify(jsonData, null, 2)], { type: "application/json" });

            // Create a download link
            const link = document.createElement("a");
            link.href = URL.createObjectURL(jsonBlob);
            const timestamp = new Date().toISOString().split('T')[0];
            link.download = `AccountReceivable_Success_Records_${timestamp}.json`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            openNotificationWithIcon(
              "success",
              "JSON Export Successful",
              `${successRecords.length} success records exported successfully.`,
              "bottomLeft"
            );
          } catch (error) {
            console.error("Error generating JSON file:", error);
            openNotificationWithIcon(
              "error",
              "JSON Generation Failed",
              "An error occurred while generating the JSON file.",
              "bottomLeft"
            );
          }
        },
      },
    ];
  };
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    if (!notificationShown.current) {
      notification[type]({
        message: message,
        description: description,
        placement,
      });
      notificationShown.current = true;
      setTimeout(() => {
        notificationShown.current = false;
      }, 5000);
    }
  };
  const [statusTrialRecord, setStatusTrialRecord] = useState({});

  const [currentRecord, setCurrentRecord] = useState({});
  //used for cancel responce show
  const [cancelResponceList, setCancelResponceList] = useState({
    cancelSuccessList: '',
    cancelFailedList: ''
  });

  const openNotification = () => {
    const key = `progressNotification_${Date.now()}`;

    // Open the initial notification
    api.open({
      key,
      message: 'Preparing Your File',
      description: (
        <div>
          <p>Your file is being prepared. Please wait...</p>
          <Progress percent={downloadProgress} status="active" />
        </div>
      ),
      duration: 0,
    });

    // Start the download process
    startDownloadProcess(key);
  };

  const startDownloadProcess = (notificationKey) => {
    setIsDownloading(true);
    setDownloadProgress(0);

    // Simulate download progress (replace with actual download logic)
    const interval = setInterval(() => {
      setDownloadProgress(prev => {
        const newProgress = Math.min(prev + 10, 100);

        // Update the notification
        api.open({
          key: notificationKey,
          message: newProgress >= 100 ? 'File Ready!' : 'Preparing Your File',
          description: (
            <div>
              {newProgress >= 100 ? (
                <p>Your file is ready for download!</p>
              ) : (
                <p>Your file is being prepared. Please wait...</p>
              )}
              <Progress
                percent={newProgress}
                status={newProgress >= 100 ? 'success' : 'active'}
              />
            </div>
          ),
          duration: newProgress >= 100 ? 2 : 0,
        });

        if (newProgress >= 100) {
          clearInterval(interval);
          setIsDownloading(false);
          // Trigger actual download here
        }

        return newProgress;
      });
    }, 500);


  };


  useEffect(() => {
    return () => {

      if (isDownloading) {

      }
    };
  }, [isDownloading]);

  //Bulk cancel Button click
  const onCancelChange = () => {
    // Check if more than 12 records are selected
    if (selectedRecords.length > 12) {
      openNotificationWithIcon(
        "error",
        "Too Many Records Selected",
        "You can only cancel a maximum of 12 records at a time. Please select 12 or fewer records.",
        "bottomLeft"
      );
      return;
    }

    setPayload({
      "fromDate": dayjs().format(dateFormat),
      "toDate": dayjs().format(dateFormat),
      "documentType": [],
      "classification": [],
      "supplierName": "",
      "buyerName": [],
      "invoiceNumber": [],
      "status": [],
    });
    //Added new property to the selected state uploadDate: dayjs(rowValue.uploadedDateAndTime).format('YYYY-MM-DD HH:mm:ss'),
    let selectedListforCancel = selectedRecords.filter(item => item.status.toLowerCase().includes('success')).map(item => {
      return {
        ...item,
        cancellationStatus: item.status == "deleted" ? "Cancellation Completed" : (item.updatedDateAndTime ? dayjs().diff(dayjs(item.updatedDateAndTime), 'hour') <= 72 : dayjs().diff(dayjs(item.uploadDate), 'hour') <= 72) ? "Ready for Cancellation" : "Cancellation Expired"
      }
    });
    setSelectedRecords(selectedListforCancel);
    setIsModalVisible(true);
  };

  //Bulk delete Button click
  const onDeleteChange = () => {
    // Filter selected records that can be deleted (not pending, submitted, or success)
    let selectedListforDelete = selectedRecords.map(item => {
      const status = item.status?.toLowerCase();
      const canDelete = status !== 'pending' && status !== 'submitted' && status !== 'success';
      return {
        ...item,
        canDelete: canDelete,
        deleteStatus: canDelete ? "Ready for Deletion" : "Cannot Delete - " + 
          (status === 'pending' ? 'Pending Status' : 
           status === 'submitted' ? 'Already Submitted' : 
           status === 'success' ? 'Success Status' : 'Invalid Status')
      }
    });
    setSelectedRecords(selectedListforDelete);
    setIsDeleteModalVisible(true);
  };

  //cancel popup submit button click
  const handleCancelInvoiceClick = () => {
    const cancellingRecords = []
    // Filter only invoices that are ready for cancellation (not expired)
    selectedRecords.filter((rec) => {
      if (rec.cancellationStatus === "Ready for Cancellation") {
        cancellingRecords.push({
          TPS_Id: rec.tPS_Id,
          MOGU_UUID: rec.documentMoguID,
          invoiceNumber: rec.invoiceNumber,
          reason: (cancelRemark.trim()) ? cancelReason + " - " + cancelRemark : cancelReason,
        });
      }
    });

    setCancelConfirmedRecords({
      cancelling: cancellingRecords,
    })

    setIsPopconfirmVisible(true);
  };



  useEffect(() => {
    //decode token
    if (token !== null) {
      GetDocumentTypes();
      GetDocumentClassification();
      GetStatusOptions(); // Call GetStatusOptions here
      fetchCompanyData();
    }
  }, [companyId,/*groupId*/]);

  // Function to fetch company data and check lhdnSubmission status
  const getDefaultDates = (documentLoadDays = null) => {
    const toDate = dayjs().endOf('day');
    const fromDate = documentLoadDays 
      ? dayjs().subtract(documentLoadDays, 'day').startOf('day')
      : dayjs().startOf('day');
    return { fromDate, toDate };
  };

  // Function to fetch company data and check lhdnSubmission status
  const fetchCompanyData = async () => {
    try {
      const companyId = localStorage.getItem('companyId');
      if (companyId) {
        const response = await CompanyAPI.getCompanyById(
          token,
          localStorage.getItem('groupId'),
          localStorage.getItem('companyId'),
          companyId
        );
        if (response?.data) {
          setCompanyData(response.data);
          setIsLhdnSubmissionBlocked(response.data.lhdnSubmission === true);
        }
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  useEffect(() => {
    // Only call if allDocumentTypes is loaded and not already loading
    if (allDocumentTypes && allDocumentTypes.length > 0 && !isLoadingRef.current) {
      GetRecivabelsUploadedFormats();
    }
  }, [allDocumentTypes])

  useEffect(() => {
    console.log(payload);
  }, [payload])

  // Update payload dates when companyData is loaded (only once)
  useEffect(() => {
    if (companyData && !hasUpdatedDatesRef.current) {
      const documentLoadDays = companyData?.documentLoadDays || null;
      const { fromDate, toDate } = getDefaultDates(documentLoadDays);
      
      // Only update if dates are still at initial state (current date)
      const currentFromDate = dayjs(payload.fromDate);
      const currentToDate = dayjs(payload.toDate);
      const isInitialState = currentFromDate.isSame(dayjs(), 'day') && currentToDate.isSame(dayjs(), 'day');
      
      if (isInitialState) {
        setPayload(prev => ({
          ...prev,
          fromDate: fromDate,
          toDate: toDate
        }));
        hasUpdatedDatesRef.current = true;
      }
    }
  }, [companyData, payload.fromDate, payload.toDate]);

  const disabledFutureDate = (current) => {
    return current && current > dayjs().endOf("day");
  }

  const onChangeReason = (value) => {
    setCancelReason(value);
  };

  const onChangeRemark = (e) => {
    setCancelRemark(e.target.value);
  };

  const cancellationColumns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Cancellation Status",
      dataIndex: "cancellationStatus",
      key: "cancellationStatus",
      render: (status) => (
        <Badge
          color={
            status === "Cancellation Completed"
              ? "green"
              : status === "Ready for Cancellation"
                ? "cyan"
                : "volcano"
          }
          text={status}
        />
      ),
    }
  ];

  const deletionColumns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Current Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Badge
          color={
            status === "success"
              ? "green"
              : status === "extracted"
                ? "blue"
                : status === "failed"
                  ? "red"
                  : status === "pending"
                    ? "orange"
                    : status === "on hold" || status === "onhold"
                      ? "orange"
                      : "default"
          }
          text={status.charAt(0).toUpperCase() + status.slice(1)}
        />
      ),
    },
    {
      title: "Deletion Status",
      dataIndex: "deleteStatus",
      key: "deleteStatus",
      render: (status, record) => (
        <Badge
          color={
            status === "Ready for Deletion"
              ? "green"
              : "red"
          }
          text={status}
        />
      ),
    },
  ];
  // cancel poupconfirm ok button click
  const handleOk = () => {
    setIsPopconfirmVisible(false);

    const payload = []
    selectedRecords.map((row) => {
      if (row.cancellationStatus === "Ready for Cancellation") {
        payload.push({
          TPS_Id: row.tPS_Id,
          MOGU_UUID: row.documentMoguID,
          invoiceNumber: row.invoiceNumber,
          reason: (cancelRemark.trim()) ? cancelReason + " - " + cancelRemark : cancelReason,
        });
      }
    });

    const reqPayload = {
      companyId: localStorage.getItem("companyId"),
      cancelList: payload
    }
    if (payload.length > 0) {
      // Set processing status
      const invoiceNumbers = payload.map(p => p.invoiceNumber).join(", ");
      
      // Show loading notification with invoice list
      const loadingKey = `cancellation_${Date.now()}`;
      api.open({
        key: loadingKey,
        message: 'Document Cancellation in Progress',
        description: (
          <div>
            <p>Cancelling {payload.length} document{payload.length > 1 ? 's' : ''}...</p>
            <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
              <strong>Invoices:</strong> {invoiceNumbers}
            </div>
          </div>
        ),
        duration: 0,
        icon: <Spin />,
      });
      
      documentManagementAPI.cancelDocument(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), reqPayload)
        .then((response) => {
          // we have to display the successfull and failed invoice which is sent for cancel
          api.destroy(loadingKey);
          
          // Handle new API response format
          if (response?.notification) {
            const notificationData = response.notification;
            const data = notificationData.data || {};
            
            // Show success notification with details
            openNotificationWithIcon(
              "success",
              notificationData.title || "Document Cancellation Complete",
              notificationData.message || `Cancellation process completed: ${data.successCount || 0} successful, ${data.failedCount || 0} failed out of ${data.totalCount || 0} documents`,
              "bottomLeft"
            );
            
            // Set cancel response list for modal display
            const cancelFailedList = (data.results || []).filter((rowValue) => {
              return rowValue.status === "failed";
            }).map(row => `Invoice No: ${row.invoiceNumber} - Failed Reason: ${row.reason || 'Unknown'}`).join(", ");
            const cancelSuccesList = (data.results || []).filter((rowValue) => rowValue.status === "success").map(row => row.invoiceNumber).join(", ");
            setCancelResponceList({
              cancelFailedList: cancelFailedList,
              cancelSuccessList: cancelSuccesList
            });
          } else {
            // Fallback to old response format
            const cancelFailedList = response.filter((rowValue) => {
              return rowValue.status === "failed";
            }).map(row => `Invoice No: ${row.invoiceNumber} - Failed Reason: ${row.reason}`).join(", ");
            const cancelSuccesList = response.filter((rowValue) => rowValue.status === "success").map(row => row.invoiceNumber).join(", ");
            setCancelResponceList({
              cancelFailedList: cancelFailedList,
              cancelSuccessList: cancelSuccesList
            });
            
            openNotificationWithIcon(
              "success",
              "Document Cancellation Complete",
              `Cancellation process completed: ${cancelSuccesList.split(", ").length} successful, ${cancelFailedList.split(", ").filter(f => f).length} failed out of ${payload.length} documents`,
              "bottomLeft"
            );
          }
        })
        .catch((err) => {
          // Close loading notification
          api.destroy(loadingKey);
          
          if (err.response) {
            openNotificationWithIcon("error", "Cancel Document Failed", `${err.response.data.message}`, "bottomLeft");
          } else {
            openNotificationWithIcon("error", "Cancel Document Failed", `${err.message}`, "bottomLeft");
          }
        });
    }
    else {
      openNotificationWithIcon("error", "Cancel Document Failed", `Invalid Selection of Invoices`, "bottomLeft");
    }
    setIsModalVisible(false);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setIsModalOpen(false);
  };


  const handleCancelPopConfirm = () => {
    setCancelButtonDisabled(true);
    openNotificationWithIcon(
      "error",
      "Abort",
      `Invoice Cancellation aborted`,
      "bottomLeft"
    );

    setTimeout(() => {
      setCancelButtonDisabled(false);
    }, 3000);

  }

  //Delete popup submit button click
  const handleDeleteInvoiceClick = () => {
    const deletingRecords = selectedRecords.filter(rec => rec.canDelete === true);
    
    setCancelConfirmedRecords({
      deleting: deletingRecords,
    });

    setIsPopconfirmVisible(true);
  };

  //Delete popconfirm ok button click
  const handleDeleteOk = () => {
    setIsPopconfirmVisible(false);

    const deletableRecords = selectedRecords.filter(row => {
      const status = row.status?.toLowerCase();
      return status !== 'pending' && status !== 'submitted' && status !== 'success';
    });
    
    if (deletableRecords.length > 0) {
      // Create invoices array with MOGU_UUID and TPS_Id pairs
      const invoices = deletableRecords.map(row => ({
        MOGU_UUID: row.documentMoguID,
        TPS_Id: row.tPS_Id
      }));
      
      const payload = {
        invoices: invoices,
        isActive: false
      };

      documentManagementAPI.deleteMultipleInvoices(token, payload)
        .then((response) => {
          if (response.status === 'success') {
            // Show main success notification with summary
            openNotificationWithIcon(
              "success",
              "Delete Invoice",
              `Successfully deleted ${response.summary.successful} out of ${response.summary.total} invoices`,
              "bottomLeft"
            );
            
            // Show detailed results if there were failures
            if (response.summary.failed > 0) {
              const failedInvoices = response.results.filter(r => r.status === 'failed');
              failedInvoices.forEach(failed => {
                openNotificationWithIcon(
                  "warning",
                  "Delete Failed",
                  `Invoice ${failed.TPS_Id}: ${failed.message}`,
                  "bottomLeft"
                );
              });
            }
            
            // Refresh the table data after successful deletion
            GetRecivabelsUploadedFormats();
          } else {
            openNotificationWithIcon(
              "error",
              "Delete Invoice Failed",
              response.message || "Failed to delete invoices",
              "bottomLeft"
            );
          }
        })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon(
              "error",
              "Delete Invoice Failed",
              `${err.response.data.message}`,
              "bottomLeft"
            );
          } else {
            openNotificationWithIcon(
              "error",
              "Delete Invoice Failed",
              `${err.message}`,
              "bottomLeft"
            );
          }
        });
    } else {
      openNotificationWithIcon("error", "Delete Invoice Failed", `No deletable invoices selected`, "bottomLeft");
    }
    
    setIsDeleteModalVisible(false);
    setIsModalOpen(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setIsModalOpen(false);
  };

  const handleDeletePopConfirm = () => {
    setDeleteButtonDisabled(true);
    openNotificationWithIcon(
      "error",
      "Abort",
      `Invoice Deletion aborted`,
      "bottomLeft"
    );

    setTimeout(() => {
      setDeleteButtonDisabled(false);
    }, 3000);
  }
  // Open the Drawer in the Create component
  const showChildDrawer = () => {
    if (createRef.current) {
      createRef.current.openDrawer();
    }
  };

  const showInvoiceDrawer = () => {
    // Multiple item select from check box - only submit extracted status records
    if (invoiceRef.current && selectedRows.length > 0) {
      // Filter only extracted status records from all selected rows
      let extractedRecords = selectedRows
        .filter(item => item.status === 'extracted' || item.status === 'failed submittable')
        .filter(item => item.invoiceNumber !== "N/A" && !item.isDuplicate && !item.isTaxMismatch && !item.isRequiredTPCompanyCodeMissing);
      
      if (extractedRecords.length === 0) {
        openNotificationWithIcon(
          "error",
          "No Submittable Records",
          "No extracted or failed submittable records found in your selection. Please select records with 'extracted' or 'failed submittable' status that are not duplicates or have tax mismatches.",
          "bottomLeft"
        );
        return;
      }

      let filterList = extractedRecords.map(item => item.invoiceNumber);
      selectedinvoiceRef.current = filterList;
      invoiceRef.current.openDrawer(filterList);
      
      // Show notification about filtered records
      if (extractedRecords.length < selectedRows.length) {
        openNotificationWithIcon(
          "info",
          "Records Filtered",
          `${extractedRecords.length} of ${selectedRows.length} selected records are eligible for submission.`,
          "bottomLeft"
        );
      }
    }
  };

  const shareDocumentDrawer = (record = null) => {

    if (record != null) {
      setSelectedRecordsUpdated([record])
    } else {
      let successInvoices = selectedRecords.filter(item => item.status.toLowerCase().includes('success'));
      setSelectedRecordsUpdated(successInvoices);
    }

    if (shareDocumentRef.current) {
      shareDocumentRef.current.openDrawer();
    }
  };
  const viewDocumentDrawer = (record) => {
    if (viewDocumentRef.current) {
      viewDocumentRef.current.openDrawer(record);
    }
  };
  const statusTrialDrawer = (record) => {
    setStatusTrialRecord(record);
    setIsStatusTrialOpen(true);
  };

  const closeStatusTrailDrawer = () => {
    setIsStatusTrialOpen(false);
  };

  // Handle selection change
  const handleSelectChange = (selectedKeys, selectedRows) => {
    setSelectedRows(selectedRows);
    if (selectedKeys.length > 0) {
      setIsRecordSelected(true);
      
      // Check if any selected records are submittable (extracted or failed submittable, not duplicate, not tax mismatch)
      const hasSubmittableRecords = selectedRows.some(item => 
        (item.status === 'extracted' || item.status === 'failed submittable') &&
        item.invoiceNumber !== "N/A" &&
        !item.isDuplicate &&
        !item.isTaxMismatch &&
        !item.isRequiredTPCompanyCodeMissing
      );
      setIsSelectedRecordSubmittable(hasSubmittableRecords);
      
      setIsCancelBtnDisable(selectedRows.some(item => item.status === 'success'));
      setIsShareBtnDisable(selectedRows.some(item => item.status === 'success' || item.status === 'extracted'));
      
      // Check if any selected records have non-deletable statuses (pending, submitted, or success)
      const nonDeletableStatuses = ['pending', 'submitted', 'success'];
      const hasNonDeletableRecords = selectedRows.some(item => {
        const status = item.status?.toLowerCase();
        return nonDeletableStatuses.includes(status);
      });
      
      // Get the list of non-deletable statuses found in selected records
      const foundNonDeletableStatuses = selectedRows
        .map(item => item.status?.toLowerCase())
        .filter(status => nonDeletableStatuses.includes(status))
        .filter((status, index, self) => self.indexOf(status) === index); // Remove duplicates
      
      // Disable delete button if any selected record has non-deletable status
      setIsDeleteBtnDisable(selectedRows.length > 0 && !hasNonDeletableRecords);
      
      // Set disable reason message
      if (hasNonDeletableRecords && selectedRows.length > 0) {
        const statusLabels = {
          'pending': 'Pending',
          'submitted': 'Submitted',
          'success': 'Success'
        };
        const statusList = foundNonDeletableStatuses.map(s => statusLabels[s] || s).join(', ');
        setDeleteButtonDisableReason(
          `Invoices with '${statusList}' status cannot be deleted. Only invoices with 'Extracted', 'Failed', 'Failed-Validation', 'Cancelled', or 'Failed Submitable' status can be deleted.`
        );
      } else {
        setDeleteButtonDisableReason('');
      }
      
      setIsdownloadBtnDisable(selectedRows.some(item => item.status === 'success' || item.status === 'extracted'));
    }
    else {
      setIsRecordSelected(false);
      setIsSelectedRecordSubmittable(false);
      setIsCancelBtnDisable(false);
      setIsShareBtnDisable(false);
      setIsDeleteBtnDisable(false);
      setDeleteButtonDisableReason('');
      setIsdownloadBtnDisable(false)
    }

    let selectdInvoices = selectedRows.map((item) => {
      if (item.invoiceNumber !== "N/A")
        return item.invoiceNumber;
      else
        return null;
    }).filter((item) => item !== null);
    setSelectedRecords(selectedRows)
    setSelectedRowKeys(selectedKeys);
    selectedinvoiceRef.current = selectdInvoices;
  };

  // Column search functionality
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select(), 100);
      }
    },
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const upload = () => {
    navigate('../AccountReceivable/Upload');
  };

  // Helper function to check if a single row matches all filter criteria (for streaming)
  const doesRowMatchFilters = (row, filterPayload, dateFrom = null, dateTo = null) => {
    // Apply date filter if provided
    if (dateFrom && dateTo) {
      if (!row.uploadDate) return false;
      try {
        const uploadDate = dayjs(row.uploadDate, 'YYYY-MM-DD HH:mm:ss').startOf('day');
        const fromDate = dayjs(dateFrom, 'YYYY-MM-DD HH:mm:ss').startOf('day');
        const toDate = dayjs(dateTo, 'YYYY-MM-DD HH:mm:ss').startOf('day');
        
        if (!uploadDate.isValid() || !fromDate.isValid() || !toDate.isValid()) {
          return false;
        }
        
        if (!(uploadDate.isSameOrAfter(fromDate) && uploadDate.isSameOrBefore(toDate))) {
          return false;
        }
      } catch (error) {
        console.error('Error in date filter:', error, row);
        return false;
      }
    }
    
    // Apply supplier name filter
    if (filterPayload.supplierName && (filterPayload.supplierName?.trim() || "") !== "") {
      let userInput = filterPayload.supplierName.trim().toLowerCase();
      const cleanUserInput = userInput.replace(/([.+^=!:${}()|\[\]\/\\])/g, '');
      const regex = new RegExp(cleanUserInput, 'i');
      let cleanSupplierName = row.supplierName.replace(/([.+^=!:${}()|\[\]\/\\])/g, '').trim().toLowerCase();
      if (!regex.test(cleanSupplierName)) {
        return false;
      }
    }
    
    // Apply buyer name filter
    if (filterPayload.buyerName && filterPayload.buyerName.length > 0) {
      let cleanBuyerName = row.buyerName.replace(/([.+^=!:${}()|\[\]\/\\])/g, '').trim().toLowerCase();
      const matches = filterPayload.buyerName.some(buyerName => {
        let cleanUserInput = buyerName.trim().toLowerCase();
        const cleanUserInputRegex = cleanUserInput.replace(/([.+^=!:${}()|\[\]\/\\])/g, '');
        const regex = new RegExp(cleanUserInputRegex, 'i');
        return regex.test(cleanBuyerName);
      });
      if (!matches) {
        return false;
      }
    }
    
    // Apply company code filter
    if (filterPayload.companyCode && filterPayload.companyCode.length > 0) {
      let cleanCompanyCode = (row.companyCode || "").trim().toLowerCase();
      const matches = filterPayload.companyCode.some(code => {
        let cleanUserInput = code.trim().toLowerCase();
        return cleanCompanyCode.includes(cleanUserInput);
      });
      if (!matches) {
        return false;
      }
    }
    
    // Apply invoice number filter
    if (filterPayload.invoiceNumber && filterPayload.invoiceNumber.length > 0) {
      if (!row.invoiceNumber || row.invoiceNumber === "N/A" || row.invoiceNumber === "Unknown") {
        return false;
      }
      try {
        let cleanInvoiceNumber = String(row.invoiceNumber).toLowerCase().trim();
        const matches = filterPayload.invoiceNumber.some(invoiceNum => {
          if (!invoiceNum) return false;
          let cleanUserInput = String(invoiceNum).trim().toLowerCase();
          return cleanInvoiceNumber.includes(cleanUserInput);
        });
        if (!matches) {
          return false;
        }
      } catch (error) {
        console.error('Error filtering invoice number:', error, row);
        return false;
      }
    }
    
    // Apply document type filter
    if (filterPayload.documentType && filterPayload.documentType.length > 0) {
      const matches = filterPayload.documentType.some(selectedDocType => {
        if (selectedDocType === "00") return false; // Skip "All" option
        let documentTypeName = allDocumentTypes.find(item => item.value === selectedDocType);
        return documentTypeName && row.documentType === documentTypeName.label;
      });
      if (!matches) {
        return false;
      }
    }
    
    // Apply classification filter
    if (filterPayload.classification && filterPayload.classification.length > 0) {
      const matches = filterPayload.classification.some(selectedClassification => {
        if (selectedClassification === "000") return false; // Skip "All" option
        return row.classification === selectedClassification;
      });
      if (!matches) {
        return false;
      }
    }
    
    // Apply status filter
    if (filterPayload.status && filterPayload.status.length > 0) {
      const matches = filterPayload.status.some(selectedStatus => {
        return row.status.toLowerCase() === selectedStatus.toLowerCase();
      });
      if (!matches) {
        return false;
      }
    }
    
    // All filters passed
    return true;
  };

  // Helper function to apply filters to data
  const applyFiltersToData = (data, filterPayload, dateFrom = null, dateTo = null) => {
    let filtered = [...data];
    
    // Apply date filter if provided
    if (dateFrom && dateTo) {
      filtered = filtered.filter(element => {
        if (!element.uploadDate) return false;
        try {
          const uploadDate = dayjs(element.uploadDate, 'YYYY-MM-DD HH:mm:ss').startOf('day');
          const fromDate = dayjs(dateFrom, 'YYYY-MM-DD HH:mm:ss').startOf('day');
          const toDate = dayjs(dateTo, 'YYYY-MM-DD HH:mm:ss').startOf('day');
          
          if (!uploadDate.isValid() || !fromDate.isValid() || !toDate.isValid()) {
            return false;
          }
          
          return uploadDate.isSameOrAfter(fromDate) && uploadDate.isSameOrBefore(toDate);
        } catch (error) {
          console.error('Error in date filter:', error, element);
          return false;
        }
      });
    }
    
    // Apply supplier name filter
    if (filterPayload.supplierName && (filterPayload.supplierName?.trim() || "") !== "") {
      let userInput = filterPayload.supplierName.trim().toLowerCase();
      const cleanUserInput = userInput.replace(/([.+^=!:${}()|\[\]\/\\])/g, '');
      const regex = new RegExp(cleanUserInput, 'i');
      filtered = filtered.filter((element) => {
        let cleanSupplierName = element.supplierName.replace(/([.+^=!:${}()|\[\]\/\\])/g, '').trim().toLowerCase();
        return regex.test(cleanSupplierName);
      });
    }
    
    // Apply buyer name filter
    if (filterPayload.buyerName && filterPayload.buyerName.length > 0) {
      filtered = filtered.filter(element => {
        let cleanBuyerName = element.buyerName.replace(/([.+^=!:${}()|\[\]\/\\])/g, '').trim().toLowerCase();
        return filterPayload.buyerName.some(buyerName => {
          let cleanUserInput = buyerName.trim().toLowerCase();
          const cleanUserInputRegex = cleanUserInput.replace(/([.+^=!:${}()|\[\]\/\\])/g, '');
          const regex = new RegExp(cleanUserInputRegex, 'i');
          return regex.test(cleanBuyerName);
        });
      });
    }
    
    // Apply company code filter
    if (filterPayload.companyCode && filterPayload.companyCode.length > 0) {
      filtered = filtered.filter(element => {
        let cleanCompanyCode = (element.companyCode || "").trim().toLowerCase();
        return filterPayload.companyCode.some(code => {
          let cleanUserInput = code.trim().toLowerCase();
          return cleanCompanyCode.includes(cleanUserInput);
        });
      });
    }
    
    // Apply invoice number filter
    if (filterPayload.invoiceNumber && filterPayload.invoiceNumber.length > 0) {
      filtered = filtered.filter(element => {
        if (!element.invoiceNumber || element.invoiceNumber === "N/A" || element.invoiceNumber === "Unknown") {
          return false;
        }
        try {
          let cleanInvoiceNumber = String(element.invoiceNumber).toLowerCase().trim();
          return filterPayload.invoiceNumber.some(invoiceNum => {
            if (!invoiceNum) return false;
            let cleanUserInput = String(invoiceNum).trim().toLowerCase();
            return cleanInvoiceNumber.includes(cleanUserInput);
          });
        } catch (error) {
          console.error('Error filtering invoice number:', error, element);
          return false;
        }
      });
    }
    
    // Apply document type filter
    if (filterPayload.documentType && filterPayload.documentType.length > 0) {
      filtered = filtered.filter(element => {
        return filterPayload.documentType.some(selectedDocType => {
          if (selectedDocType === "00") return false; // Skip "All" option
          let documentTypeName = allDocumentTypes.find(item => item.value === selectedDocType);
          return documentTypeName && element.documentType === documentTypeName.label;
        });
      });
    }
    
    // Apply classification filter
    if (filterPayload.classification && filterPayload.classification.length > 0) {
      filtered = filtered.filter(element => {
        return filterPayload.classification.some(selectedClassification => {
          if (selectedClassification === "000") return false; // Skip "All" option
          return element.classification === selectedClassification;
        });
      });
    }
    
    // Apply status filter
    if (filterPayload.status && filterPayload.status.length > 0) {
      filtered = filtered.filter(element => {
        return filterPayload.status.some(selectedStatus => {
          return element.status.toLowerCase() === selectedStatus.toLowerCase();
        });
      });
    }
    
    return filtered;
  };

  const handleFormSearch = async () => {
    const validateData = {
      fromDate: dayjs(payload.fromDate).format("YYYY-MM-DD HH:mm:ss"), //moment(payload.fromDate).format('YYYY-MM-DD HH:mm:ss') ,
      toDate: dayjs(payload.toDate).format("YYYY-MM-DD HH:mm:ss"),//moment(payload.toDate).format('YYYY-MM-DD HH:mm:ss'),
    };
    const validationStatus = validateBeforeSearch(validateData);
    if (validationStatus) {
      // Check if selected date range is within the default loaded date range
      const selectedFromDate = dayjs(validateData.fromDate).startOf('day').toDate();
      const selectedToDate = dayjs(validateData.toDate).endOf('day').toDate();
      const defaultStart = defaultLoadedDateRange.startDate ? dayjs(defaultLoadedDateRange.startDate).startOf('day').toDate() : null;
      const defaultEnd = defaultLoadedDateRange.endDate ? dayjs(defaultLoadedDateRange.endDate).endOf('day').toDate() : null;

      // Check if selected range is within default range
      const isWithinDefaultRange = defaultStart && defaultEnd && 
        selectedFromDate >= defaultStart && selectedToDate <= defaultEnd;

      if (!isWithinDefaultRange && defaultStart && defaultEnd) {
        //or date comparisons and you want to ignore the timestamp (i.e., compare only the dates), 
        await GetRecivabelsUploadedFormats(validateData.fromDate, validateData.toDate, payload);
        // you should normalize all dates to the start of the day using .startOf('day')
        return;
      }

      // Filter existing data if within default range
      // Use default loaded date range if available, otherwise use form dates
      const dateFilterFromDate = defaultStart ? dayjs(defaultStart).format('YYYY-MM-DD HH:mm:ss') : validateData.fromDate;
      const dateFilterToDate = defaultEnd ? dayjs(defaultEnd).format('YYYY-MM-DD HH:mm:ss') : validateData.toDate;
      
      // Use helper function to apply all filters
      const filtered = applyFiltersToData(
        accountRecivableAllData,
        payload,
        dateFilterFromDate,
        dateFilterToDate
      );

      console.log('Filtering results:', {
        totalLoaded: accountRecivableAllData.length,
        filteredCount: filtered.length,
        payload: payload
      });
      
      setAccountReceivableSearchData(filtered);
      
      // Show success message when filtering from already loaded data
      openNotificationWithIcon(
        "success",
        "Filter Applied Successfully",
        `Filtered ${filtered.length} record(s) from ${accountRecivableAllData.length} loaded record(s).`,
        "bottomLeft"
      );
    }
  }


  // const GetRecivabelsUploadedFormats = async () => {
  //   if (localStorage.getItem('companyId') !== null) {
  //     await AccountReceivableAPI.GetAccountReceivableSearchData(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'))
  //       .then((res) => {
  //         if (res?.data) {
  //           const rows = [];
  //           let tempKey = 0;
  //           res.data.map((rowValue) => {
  //             let documentCategory = allDocumentTypes.filter((type) => type.code == rowValue?.invoiceType)?.[0];
  //             rows.push({
  //               key: tempKey++,
  //               documentMoguID: rowValue?.documentMoguID,
  //               uploadedUserId: rowValue?.uploadedUserId,
  //               invoiceNumber: (!rowValue?.invoiceNumber || rowValue?.invoiceNumber.trim() === "") ? "N/A" : rowValue?.invoiceNumber,
  //               documentType: (!documentCategory?.label || documentCategory?.label.trim() === "") ? "N/A" : documentCategory?.label,
  //               classification: rowValue?.classification && parseInt(rowValue?.classification, 10) > 0 ? rowValue?.classification : "N/A", //this is an array normally include only 1 value change in future
  //               uploadDate: dayjs(rowValue.uploadedDateAndTime).format('YYYY-MM-DD HH:mm:ss'),
  //               uploadedBy: rowValue.uploadedUser,
  //               supplierName: (!rowValue.supplierName || rowValue.supplierName.trim() === "") ? "N/A" : rowValue.supplierName,
  //               buyerName: (() => {
  //                 const buyerName = rowValue.BuyerName && rowValue.BuyerName.trim() !== "" ? rowValue.BuyerName : null;
  //                 const companyCode = rowValue.companyCode && rowValue.companyCode.trim() !== "" ? rowValue.companyCode : null;
                  
  //                 if (buyerName && companyCode) {
  //                   return `${buyerName} | ${companyCode}`;
  //                 } else if (buyerName) {
  //                   return buyerName;
  //                 } else if (companyCode) {
  //                   return companyCode;
  //                 } else {
  //                   return "N/A";
  //                 }
  //               })(),
  //               companyCode: rowValue.companyCode || "",
  //               status: rowValue?.status,
  //               originalFilePath: rowValue?.originalFilePath,
  //               tiTax: rowValue?.totalTaxAmount,
  //               isActive: rowValue?.isActive,
  //               isDuplicate: rowValue?.isDuplicate,
  //               isTaxMismatch: rowValue?.isTaxMismatch,
  //               isRequiredTPCompanyCodeMissing: rowValue?.isRequiredTPCompanyCodeMissing,
  //               isLhdnSubmissionBlocked: rowValue?.isLhdnSubmissionBlocked,
  //               tPS_Id: rowValue?.TPS_Id,
  //               cancellationStatus: rowValue?.cancellationStatus,
  //               invoiceType: rowValue?.invoiceType,
  //               base64PDF: rowValue?.base64PDF,
  //               totalTaxAmount: rowValue?.totalTaxAmount,
  //               totalPayableAmount: rowValue?.totalPayableAmount,
  //               url: rowValue.url || "",
  //               InvoiceDateTime: rowValue.InvoiceDateTime ? dayjs(rowValue.InvoiceDateTime).format('YYYY-MM-DD HH:mm:ss') : "",
  //               uuid: rowValue?.uuid || "",
  //               peppol: rowValue?.peppol,
  //             })
  //           });
  //           setAccountReceivableSearchData(rows);
  //           setAccountRecivableAllData(rows);
  //           // Extract unique company codes for dropdown options
  //           const uniqueCompanyCodes = [...new Set(
  //             res.data
  //               .map(item => item.companyCode)
  //               .filter(code => code && code.trim() !== "")
  //           )].sort();
  //           const companyCodeOpts = uniqueCompanyCodes.map(code => ({ value: code, label: code }));
  //           setCompanyCodeOptions(companyCodeOpts);

  //         }
  //       })
  //       .catch((err) => {
  //         if (err.response) {
  //           openNotificationWithIcon('error', 'No data found', `${err.response.data.message}`, 'bottomLeft');
  //         } else {
  //           openNotificationWithIcon('error', 'No data found', `${err.message}`, 'bottomLeft');
  //         }
  //       });
  //   }
  //   else {
  //     setAccountReceivableSearchData([]);
  //     setAccountRecivableAllData([]);
  //     openNotificationWithIcon('info', 'Information', "Please select a Group and Company.", 'bottomLeft');
  //   }
  // }

  // Helper function to process row data
  const processRowData = (rowValue, tempKey) => {
    let documentCategory = allDocumentTypes.find(
      (type) => type.code === rowValue?.invoiceType
    );

    return {
      key: tempKey,
      documentMoguID: rowValue?.documentMoguID,
      uploadedUserId: rowValue?.uploadedUserId,
      invoiceNumber:
        rowValue?.invoiceNumber?.trim() ? rowValue.invoiceNumber : "N/A",
      documentType: documentCategory?.label || "N/A",
      classification:
        parseInt(rowValue?.classification, 10) > 0
          ? rowValue.classification
          : "N/A",
      uploadDate: dayjs(rowValue.uploadedDateAndTime).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      updatedDateAndTime: rowValue.updatedDateAndTime ? dayjs(rowValue.updatedDateAndTime).format(
        "YYYY-MM-DD HH:mm:ss"
      ) : null,
      uploadedBy: rowValue.uploadedUser,
      supplierName: rowValue?.supplierName?.trim()
        ? rowValue.supplierName
        : "N/A",
      buyerName:
        rowValue?.BuyerName || rowValue?.companyCode
          ? `${rowValue?.BuyerName || ""}${
              rowValue?.BuyerName && rowValue?.companyCode ? " | " : ""
            }${rowValue?.companyCode || ""}`
          : "N/A",
      companyCode: rowValue.companyCode || "",
      status: rowValue?.status,
      originalFilePath: rowValue?.originalFilePath,
      tiTax: rowValue?.totalTaxAmount,
      isActive: rowValue?.isActive,
      isDuplicate: rowValue?.isDuplicate,
      isTaxMismatch: rowValue?.isTaxMismatch,
      isRequiredTPCompanyCodeMissing: rowValue?.isRequiredTPCompanyCodeMissing,
      isLhdnSubmissionBlocked: rowValue?.isLhdnSubmissionBlocked,
      tPS_Id: rowValue?.TPS_Id,
      cancellationStatus: rowValue?.cancellationStatus,
      invoiceType: rowValue?.invoiceType,
      base64PDF: rowValue?.base64PDF,
      totalTaxAmount: rowValue?.totalTaxAmount,
      totalPayableAmount: rowValue?.totalPayableAmount,
      url: rowValue.url || "",
      InvoiceDateTime: rowValue.InvoiceDateTime ? dayjs(rowValue.InvoiceDateTime).format('YYYY-MM-DD HH:mm:ss') : "",
      uuid: rowValue?.uuid || "",
      peppol: rowValue?.peppol,
    };
  };

  const GetRecivabelsUploadedFormats = async (fromDate = null, toDate = null, filterPayload = null) => {
    // Prevent duplicate calls
    if (isLoadingRef.current) {
      return;
    }
    isLoadingRef.current = true;

    if (!localStorage.getItem("companyId")) {
      isLoadingRef.current = false;
      openNotificationWithIcon(
        "info",
        "Information",
        "Please select a Group and Company.",
        "bottomLeft"
      );
      return;
    }

    // Get company data if not available
    let currentCompanyData = companyData;
    if (!currentCompanyData) {
      try {
        const companyId = localStorage.getItem('companyId');
        if (companyId) {
          const response = await CompanyAPI.getCompanyById(
            token,
            localStorage.getItem('groupId'),
            localStorage.getItem('companyId'),
            companyId
          );
          if (response?.data) {
            currentCompanyData = response.data;
            setCompanyData(response.data);
          }
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
      }
    }

    // Calculate default date range if not provided
    const documentLoadDays = currentCompanyData?.documentLoadDays || 30;
    let actualFromDate = fromDate;
    let actualToDate = toDate;

    if (!fromDate || !toDate) {
      // Calculate default date range based on documentLoadDays
      const endDate = dayjs().endOf('day');
      const startDate = dayjs().subtract(documentLoadDays, 'day').startOf('day');
      actualFromDate = startDate.format("YYYY-MM-DD HH:mm:ss");
      actualToDate = endDate.format("YYYY-MM-DD HH:mm:ss");
      
      // Store default loaded date range
      setDefaultLoadedDateRange({
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
      });
    }

    // Reset states
    setAccountReceivableSearchData([]);
    setAccountRecivableAllData([]);
    setLoadedCount(0);
    setTotalCount(0);
    lastProgressRef.current = 0;
    if (updateProgressTimeoutRef.current) {
      clearTimeout(updateProgressTimeoutRef.current);
    }

    setIsLoading(true);
    setProgress(0);

    let tempKey = 0;
    let loaded = 0;
    let total = 0;
    const companyCodesSet = new Set();
    const rowBuffer = [];
    const BATCH_SIZE = 50; // Process rows in batches of 50
    let batchTimeoutId = null;
    const allLoadedRows = []; // Track all loaded rows for filtering

    // Throttled progress update function
    const updateProgress = (currentLoaded, currentTotal) => {
      if (updateProgressTimeoutRef.current) {
        clearTimeout(updateProgressTimeoutRef.current);
      }
      
      updateProgressTimeoutRef.current = setTimeout(() => {
        if (currentTotal > 0) {
          const newPercent = Math.min(
            Math.round((currentLoaded / currentTotal) * 100),
            100
          );
          // Check if the element's invoice number matches any of the selected invoice numbers
          if (newPercent >= lastProgressRef.current) {
            lastProgressRef.current = newPercent;
            setLoadedCount(currentLoaded);
            setProgress(newPercent);
          }
        }
      }, 50); // Update every 50ms for smooth progress
    };

    // Process batched rows asynchronously to prevent blocking
    const processBatch = (onComplete = null) => {
      if (rowBuffer.length === 0) {
        if (onComplete) onComplete();
        return;
      }

      const batch = rowBuffer.splice(0, BATCH_SIZE);
      const newRows = [];

      const allRowsInBatch = []; // Track all rows in this batch
      
      batch.forEach((rowValue) => {
        loaded++;
        updateProgress(loaded, total);

        // Collect company codes for dropdown
        if (rowValue.companyCode && rowValue.companyCode.trim() !== "") {
          companyCodesSet.add(rowValue.companyCode);
        }

        const row = processRowData(rowValue, tempKey++);
        allRowsInBatch.push(row); // Track all rows in this batch
        allLoadedRows.push(row); // Track all loaded rows for final filtering if needed
        
        // If filters are provided, check if row matches filters before adding to newRows
        // Check if filterPayload exists and has any active filters
        const hasActiveFilters = filterPayload && (
          (filterPayload.status && filterPayload.status.length > 0) ||
          (filterPayload.invoiceNumber && filterPayload.invoiceNumber.length > 0) ||
          (filterPayload.supplierName && filterPayload.supplierName && filterPayload.supplierName.trim() !== "") ||
          (filterPayload.buyerName && filterPayload.buyerName.length > 0) ||
          (filterPayload.companyCode && filterPayload.companyCode.length > 0) ||
          (filterPayload.documentType && filterPayload.documentType.length > 0) ||
          (filterPayload.classification && filterPayload.classification.length > 0)
        );
        
        if (hasActiveFilters) {
          const matches = doesRowMatchFilters(row, filterPayload, actualFromDate, actualToDate);
          if (matches) {
            newRows.push(row);
          }
          // Check if the element's document type matches any of the selected document types
        } else {
          // Check if the element's classification matches any of the selected classifications
          newRows.push(row);
        }
      });

      // Batch state update
      if (allRowsInBatch.length > 0) {
        // Always update accountRecivableAllData with all rows (for tracking)
        setAccountRecivableAllData((prev) => [...prev, ...allRowsInBatch]);
        
        // Update search data with filtered rows (or all rows if no filters)
        // Check if filterPayload exists and has any active filters
        const hasActiveFilters = filterPayload && (
          (filterPayload.status && filterPayload.status.length > 0) ||
          (filterPayload.invoiceNumber && filterPayload.invoiceNumber.length > 0) ||
          (filterPayload.supplierName && filterPayload.supplierName && filterPayload.supplierName.trim() !== "") ||
          (filterPayload.buyerName && filterPayload.buyerName.length > 0) ||
          (filterPayload.companyCode && filterPayload.companyCode.length > 0) ||
          (filterPayload.documentType && filterPayload.documentType.length > 0) ||
          (filterPayload.classification && filterPayload.classification.length > 0)
        );
        
        if (hasActiveFilters) {
          // Check if the element's status matches any of the selected statuses
          setAccountReceivableSearchData((prev) => [...prev, ...newRows]);
        } else {
          // No filters, add all rows
          if (newRows.length > 0) {
            setAccountReceivableSearchData((prev) => [...prev, ...newRows]);
          }
        }
      }

      // Process next batch if there are more rows
      if (rowBuffer.length > 0) {
        batchTimeoutId = setTimeout(() => processBatch(onComplete), 0);
      } else if (onComplete) {
        // All batches processed, call completion callback
        onComplete();
      }
    };
  
    try {
      await AccountReceivableAPI.GetAccountReceivableSearchData(
        token,
        localStorage.getItem("groupId"),
        localStorage.getItem("companyId"),
  
        //ON ROW - Add to buffer instead of processing immediately
        (rowValue) => {
          rowBuffer.push(rowValue);
          
          // Start processing if buffer reaches batch size or if this is the first item
          if (rowBuffer.length >= BATCH_SIZE && !batchTimeoutId) {
            batchTimeoutId = setTimeout(processBatch, 0);
          } else if (rowBuffer.length === 1) {
            // Process first batch immediately
            batchTimeoutId = setTimeout(processBatch, 0);
          }
        },
  
        //ON META (TOTAL COUNT)
        (totalCount) => {
          total = totalCount;
          setTotalCount(totalCount);
          // Update progress when total is known (even if loaded is 0, to show initial progress)
          updateProgress(loaded, total);
        },

        // ON DONE
        () => {
          // Process any remaining rows in buffer, then finalize
          const finalize = () => {
            // Extract unique company codes for dropdown options
            if (updateProgressTimeoutRef.current) {
              clearTimeout(updateProgressTimeoutRef.current);
            }
            if (batchTimeoutId) {
              clearTimeout(batchTimeoutId);
            }
            // Ensure final progress is set correctly
            const finalCount = total || loaded;
            setLoadedCount(finalCount);
            lastProgressRef.current = 100;
            setIsLoading(false);
            setProgress(100);
            
            // Update company code options
            const uniqueCompanyCodes = Array.from(companyCodesSet).sort();
            const companyCodeOpts = uniqueCompanyCodes.map(code => ({ value: code, label: code }));
            setCompanyCodeOptions(companyCodeOpts);

            // Filters were already applied during streaming if filterPayload was provided
            if (filterPayload) {
              // Count filtered rows (they were already added to accountReceivableSearchData during streaming)
              const filteredCount = allLoadedRows.filter(row => 
                doesRowMatchFilters(row, filterPayload, actualFromDate, actualToDate)
              ).length;
              
              openNotificationWithIcon(
                "success",
                "Data Loaded and Filtered",
                `Loaded ${allLoadedRows.length} record(s) and filtered to ${filteredCount} record(s) based on your criteria.`,
                "bottomLeft"
              );
            } else {
              // No filters to apply, show standard completion message
              openNotificationWithIcon(
                "success",
                "Completed",
                "All invoices loaded",
                "bottomLeft"
              );
            }

            // Reset loading flag
            isLoadingRef.current = false;
          };

          // Process remaining rows, then finalize
          if (rowBuffer.length > 0) {
            processBatch(finalize);
          } else {
            // No remaining rows, finalize immediately
            finalize();
          }
        },
        actualFromDate,
        actualToDate
      );
    } catch (err) {
      setIsLoading(false);
      isLoadingRef.current = false;
      if (err.response) {
        openNotificationWithIcon('error', 'No data found', `${err.response.data.message}`, 'bottomLeft');
      } else {
        openNotificationWithIcon('error', 'No data found', `${err.message}`, 'bottomLeft');
      }
    }
  };
  
  

  const GetDocumentTypes = async () => {
    await AccountPayableAPI.GetDocumentTypes(token, localStorage.getItem('groupId'), /*companyId*/ localStorage.getItem('companyId'))
      .then((res) => {
        if (res?.data) {
          const documetTypes = res.data.map((rowValue) => ({
            value: rowValue.code,
            label: rowValue.description,
            code: rowValue.code
          })).sort((a, b) => a.label.localeCompare(b.label));
          setAllDocumentTypes(documetTypes);
          let selectedDocumentTypes = documetTypes.filter(type => ["Credit Note", "Debit Note", "Refund Note", "Invoice"].includes(type.label));
          selectedDocumentTypes.unshift({ label: "All", value: "00" });
          setDocumentType(selectedDocumentTypes);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Document Type found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Document Type found', `${err.message}`, 'bottomLeft');
        }
      });
  }

  const truncateText = (text, maxLength = 30) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + ' etc...' : text;
  };

  const GetDocumentClassification = async () => {
    await AccountPayableAPI.GetDocumentClassification(
      token,
      localStorage.getItem('groupId'),
      localStorage.getItem('companyId')
    )
      .then((res) => {
        if (res?.data) {
          const classification = res.data
            .map((rowValue) => ({
              value: rowValue.code,
              label: `${rowValue.code} - ${rowValue.description}`, // plain string for search
              code: rowValue.code,
              description: rowValue.description,
            }))
            .sort((a, b) => a.value.localeCompare(b.value));
  
          let selectedClassificationTypes = classification;
          selectedClassificationTypes.unshift({ label: 'All', value: '000', code: '000', description: 'All' });
  
          setclassification(selectedClassificationTypes);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Document Type found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Document Type found', `${err.message}`, 'bottomLeft');
        }
      });
  };
  

  const GetStatusOptions = () => {
    const statuses = ['pending','extracted','deleted','success','failed','cancelled','failed submittable', 'failed validation', 'duplicate', 'submitted', 'on hold'];
    const statusOptions = statuses.map(status => ({
      value: status,
      label: status.charAt(0).toUpperCase() + status.slice(1)
    }));
    statusOptions.unshift({ label: "All", value: "" });
    setStatus(statusOptions);
  }

  const validateBeforeSearch = (validateData) => {
    const validationResult = validateForm(validateData, validationRules);

    if (!validationResult.isValid) {
      const validationErr = validationResult.errors;
      const newErrors = {};
      Object.keys(validationErr).forEach((value) => {
        newErrors[value] = validationErr[value];
      })
      setErrors(newErrors);
      return false;
    } else {
      return true;
    }
  }

  const refreshTableData = async () => {
    setIsLoading(true);
    setLoadedCount(0);
    setTotalCount(0);
    await GetRecivabelsUploadedFormats();
  };
  const handleFormClear = () => {
    const documentLoadDays = companyData?.documentLoadDays || null;
    const { fromDate, toDate } = getDefaultDates(documentLoadDays);
    
    setPayload({
      "fromDate": fromDate,
      "toDate": toDate,
      "documentType": [],
      "classification": [],
      "supplierName": "",
      "buyerName": [],
      "invoiceNumber": [],
      "status": [],
    });
    setErrors({});
    setAccountReceivableSearchData(accountRecivableAllData);
  };

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules);
    if (!validationResult.isValid) {
      const err = validationResult.errors
      const newErrors = {};
      Object.keys(err).forEach((value) => {
        newErrors[value] = err[value];
      })
      setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
      const keyData = Object.keys(data)[0]
      setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
    if (Object.keys(data).length > 1) {
      let toDate = dayjs(data.toDate, dateFormat).toDate();
      let fromDate = dayjs(data.fromDate, dateFormat).toDate();
      const keyData = Object.keys(data)[0];
      if (toDate < fromDate) {

        setErrors(prev => ({ ...prev, [keyData]: 'Invalid Date Selection' }));
      }
      else {
        setErrors(prev => ({ ...prev, [keyData]: '' }));
      }
    }
  }

  const handleDownloadOriginalFile = (record) => {

    const formData = new FormData();

    formData.append("groupId", localStorage.getItem("groupId"));
    formData.append("companyId", localStorage.getItem("companyId"));
    formData.append("fileUrl", record.originalFilePath);


    documentManagementAPI.downloadOriginalDocument(token, formData)
      .then((response) => {
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }
  const handleDownloadPDF = (record) => {

    const formData = new FormData();

    formData.append("groupId", localStorage.getItem("groupId"));
    formData.append("companyId", localStorage.getItem("companyId"));
    formData.append("MOGU_UUID", record?.documentMoguID);
    formData.append("TPS_Id", record?.tPS_Id);

    documentManagementAPI.downloadPDF(token, formData)
      .then((response) => {
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }

  const handleBulkDownloadAndZip = async () => {
    if (selectedRecords.length === 0) {
      openNotificationWithIcon(
        "error",
        "No Documents Selected",
        "Please select documents to download.",
        "bottomLeft"
      );
      return;
    }

    const zip = new JSZip();
    const failedDownloads = [];

    for (const record of selectedRecords) {
      try {
        // Create a FormData object
        const formData = new FormData();
        formData.append("groupId", localStorage.getItem("groupId"));
        formData.append("companyId", localStorage.getItem("companyId"));
        formData.append("fileUrl", record.originalFilePath); // Reference the file path directly

        formData.append("MOGU_UUID", record.documentMoguID);
        formData.append("TPS_Id", record.tPS_Id);


        // Pass the FormData object to the API documentManagementAPI.downloadPDFWithQR(token,formData)
        const response = await documentManagementAPI.downloadDocumentWithQRCodeZip(token, formData);

        const blob = new Blob([response.data], { type: "application/pdf" });
        zip.file(`${record.invoiceNumber || "Document"}.pdf`, blob);
      } catch (err) {
        console.error(`Failed to download PDF for ${record.invoiceNumber}:`, err);
        failedDownloads.push(record.invoiceNumber || "Unknown Document");
      }
    }

    if (failedDownloads.length > 0) {
      openNotificationWithIcon(
        "error",
        "Download Failed",
        `Failed to download the following documents: ${failedDownloads.join(", ")}`,
        "bottomLeft"
      );
    }

    if (Object.keys(zip.files).length > 0) {
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, "Documents.zip");
      openNotificationWithIcon(
        "success",
        "Download Complete",
        "The selected documents have been downloaded as a zip file.",
        "bottomLeft"
      );
    }
  };
  const handleDownloadPDFWithQR = (record) => {

    const formData = new FormData();

    formData.append("groupId", localStorage.getItem("groupId"));
    formData.append("companyId", localStorage.getItem("companyId"));
    formData.append("MOGU_UUID", record?.documentMoguID);
    formData.append("TPS_Id", record?.tPS_Id);

    documentManagementAPI.downloadPDFWithQR(token, formData)
      .then((response) => {
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Download Original File Failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }

  const handleSubmitInvoice = (record) => {
    //handle individual invoice submission logic you have to pass the invoiceList
    let selectedInvoices = [record.invoiceNumber];
    if (invoiceRef.current) {
      invoiceRef.current.openDrawer(selectedInvoices);
    }
  }

  const handleDeleteInvoice = (record) => {

    const payload = {
      groupId: localStorage.getItem("groupId"),
      companyId: localStorage.getItem("companyId"),
      MOGU_UUID: record.documentMoguID,
      TPS_Id: record.tPS_Id,
      isActive: false
    };


    documentManagementAPI.deleteInvoice(token, payload)
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "Delete Invoice",
          `${response.message}`,
          "bottomLeft"
        );
        GetRecivabelsUploadedFormats()
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Delete Invoice Failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Delete Invoice Failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }

  const onFromDateChange = (date, dateString) => {
    if (date) {
      const validateData = { fromDate: date };
      validateFormData(validateData);
      setPayload({
        "fromDate": date.format('YYYY-MM-DD HH:mm:ss'),
        "toDate": payload.toDate,
        "documentType": payload.documentType,
        "classification": payload.classification,
        "supplierName": payload.supplierName,
        "buyerName": payload.buyerName,
        "invoiceNumber": payload.invoiceNumber,
        "status": payload.status,
      });
    }
  };

  const onToDateChange = (date, dateString) => {
    if (date) {
      const validateData = { toDate: date, fromDate: payload.fromDate };
      validateFormData(validateData);
      setPayload({
        "fromDate": payload.fromDate,
        "toDate": date.format('YYYY-MM-DD HH:mm:ss'),
        "documentType": payload.documentType,
        "classification": payload.classification,
        "supplierName": payload.supplierName,
        "buyerName": payload.buyerName,
        "invoiceNumber": payload.invoiceNumber,
        "status": payload.status,
      });
    }
  };

  const onDocumentTypeChange = (selectedDocumentTypes) => {
    setPayload(prev => ({
      ...prev,
      "documentType": selectedDocumentTypes
    }));
  };

  const onClassificationChange = (classifications) => {
    setPayload(prev => ({
      ...prev,
      "classification": classifications
    }));
  };

  const onStatusChange = (selectedStatuses) => {
    setPayload(prev => ({
      ...prev,
      "status": selectedStatuses
    }));
  };

  const getStatusColor = (status) => ({
    uploaded: '#008080',
    pending: '#ffff00',
    extracted: '#FDC483',
    'failed submittable': '#FCA746',
    submitted: '#1890ff',
    success: '#52c41a',
    failed: '#ff0000',
    deleted: '#888',
    cancelled: '#800080',
    'failed validation': '#008b8b',
    duplicate: '#ff69b4',
    'on hold': '#FF8C00',
    'onhold': '#FF8C00',
  })[status.toLowerCase()] || '#d9d9d9'; // default color if status not found

  const initialColumns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      sorter: (a, b) => a.invoiceNumber.localeCompare(b.invoiceNumber),
      percentageWidth: 0.15,
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      key: "supplierName",
      sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      percentageWidth: 0.15,
    },
    {
      title: "Buyer Name",
      dataIndex: "buyerName",
      key: "buyerName",
      sorter: (a, b) => a.buyerName.localeCompare(b.buyerName),
      percentageWidth: 0.15,
    },
    {
      title: "Document Type",
      dataIndex: "documentType",
      key: "documentType",
      sorter: (a, b) => a.documentType.localeCompare(b.documentType),
      percentageWidth: 0.15,
    },
    // {
    //   title: "Classification",
    //   dataIndex: "classification",
    //   key: "classification",
    //   sorter: (a, b) => a.classification.localeCompare(b.classification),
    //   percentageWidth: 0.15,
    // },
    {
      title: "Total Payable Amount",
      dataIndex: "totalPayableAmount",
      key: "totalPayableAmount",
      sorter: (a, b) => new Date(a.totalPayableAmount) - new Date(b.totalPayableAmount),
      percentageWidth: 0.15,
      render: (_, record) => (!isNaN(record.totalPayableAmount) ? record.totalPayableAmount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : "0.00"),
    },
    {
      title: "Uploaded By",
      dataIndex: "uploadedBy",
      key: "uploadedBy",
      sorter: (a, b) => a.uploadedBy.localeCompare(b.uploadedBy),
      percentageWidth: 0.15,
    },
    {
      title: "Upload Date and Time",
      dataIndex: "uploadDate",
      key: "uploadDate",
      sorter: (a, b) => new Date(a.uploadDate) - new Date(b.uploadDate),
      percentageWidth: 0.15,
    },
    {
      title: "Status",
      dataIndex: "status",
      percentageWidth: 0.10,
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (status) => (
        <Badge
          color={getStatusColor(status)}
          text={status.charAt(0).toUpperCase() + status.slice(1)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      percentageWidth: 0.10,
      render: (_, record) => {
        const getMenuItems = (record) => {
          const status = record.status?.toLowerCase?.() || record.status;
          
          // Special handling for cancelled status variations
          if (status && status.includes('cancel')) {
            return [
              { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
              { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
              (record.base64PDF) ? { key: "downloadPdf", label: "QR-Free PDF Download", onClick: () => handleDownloadPDF(record) } : null,
              (record.invoiceNumber !== "N/A") ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
            ];
          }
          
          switch (status) {

            case "pending":
              return [
                { key: "originalFileDownload", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
              ];

            case "extracted":
              return [
                (record.invoiceNumber !== "N/A" && (!record.isDuplicate && !record.isTaxMismatch && !record.isLhdnSubmissionBlocked && !record.isRequiredTPCompanyCodeMissing)) ? { key: "individualSubmit", label: "Submit", onClick: () => handleSubmitInvoice(record) } : null,
                { key: "originalFileDownload", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                (record.base64PDF) ? { key: "downloadPdf", label: "QR-Free PDF Download", onClick: () => handleDownloadPDF(record) } : null,
                //(record.invoiceNumber !== "N/A" && (record.isDuplicate || record.isTaxMismatch)) ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
                //Changed this to bellow code, because any user should be able to delete the invoice after the extraction
                (record.invoiceNumber !== "N/A") ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
              ];

            case "success":
              return [
                { key: "view", label: "View", onClick: () => viewDocumentDrawer(record) },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                (record.base64PDF) ? { key: "downloadPdf", label: "QR-Free PDF Download", onClick: () => handleDownloadPDF(record) } : null,
                { key: "pdfDownloadWithQR", label: "PDF Download", onClick: () => handleDownloadPDFWithQR(record) },
                (record.invoiceType === "01") ? { key: "rn", label: "Refund Note", onClick: () => upload(), } : null,
                (record.invoiceType === "01") ? { key: "creditNote", label: "Credit Note", onClick: () => upload(), } : null,
                (record.invoiceType === "01") ? { key: "debitNote", label: "Debit Note", onClick: () => upload(), } : null,
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "share", label: "Share", onClick: () => shareDocumentDrawer(record) },
                { key: "cancel", label: "Cancel", onClick: () => showSingleCancelModal(record) },
              ];

            case "failed":
              return [
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                //(record.isDuplicate || record.isTaxMismatch) ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
                //Changed this to bellow code, because any user should be able to delete the invoice after the extraction
                (record.invoiceNumber !== "N/A") ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
              ];
            case "deleted":
              return [
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
              ];

            case "failed submittable":
              return [
                (record.invoiceNumber !== "N/A" && (!record.isDuplicate && !record.isTaxMismatch && !record.isLhdnSubmissionBlocked && !record.isRequiredTPCompanyCodeMissing)) ? { key: "individualSubmit", label: "Submit", onClick: () => handleSubmitInvoice(record) } : null,
                { key: "originalFileDownload", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                (record.base64PDF) ? { key: "downloadPdf", label: "QR-Free PDF Download", onClick: () => handleDownloadPDF(record) } : null,
                (record.invoiceNumber !== "N/A" && (record.isDuplicate || record.isTaxMismatch || record.isRequiredTPCompanyCodeMissing)) ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
              ];

            case "on hold":
              return [
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                (record.base64PDF) ? { key: "downloadPdf", label: "QR-Free PDF Download", onClick: () => handleDownloadPDF(record) } : null,
                (record.invoiceNumber !== "N/A" && (record.isDuplicate || record.isTaxMismatch || record.isRequiredTPCompanyCodeMissing)) ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
              ];

            case "submitted":
              return [
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
              ];

            case "cancelled":
            case "canceled":
              return [
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                (record.base64PDF) ? { key: "downloadPdf", label: "QR-Free PDF Download", onClick: () => handleDownloadPDF(record) } : null,
                (record.invoiceNumber !== "N/A") ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
              ];

            case "failed validation":
              return [
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                (record.invoiceNumber !== "N/A") ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
              ];

            case "duplicate":
              return [
                { key: "status Trail", label: "Status Trail", onClick: () => statusTrialDrawer(record), },
                { key: "originalFile", label: "Download Original File", onClick: () => handleDownloadOriginalFile(record) },
                (record.invoiceNumber !== "N/A") ? { key: "DeleteInvoice", label: "Delete Invoice", onClick: () => handleDeleteInvoice(record) } : null,
              ];

            default:
              console.log("Unmatched status:", record.status, "Type:", typeof record.status);
              return [];
          }
        };
        const menuItems = getMenuItems(record).filter(Boolean);


        return (
          <Dropdown
            overlay={
              <Menu>
                {menuItems.map((item) => (
                  <Menu.Item
                    key={item.key}
                    onClick={item.onClick} // Add the onClick handler here
                  >
                    {item.link ? (
                      <Link to={item.link}>{item.label}</Link> // If a link is provided, render it
                    ) : (
                      item.label // Otherwise, just render the label
                    )}
                  </Menu.Item>
                ))}
              </Menu>
            }
            trigger={["click"]}
          >
            <Button type="primary" icon={<EllipsisOutlined />} />
          </Dropdown>
        );
      },
    },
  ];
  const navigate = useNavigate();
  // Compute an initial container width using window.innerWidth as fallback.
  const initialContainerWidth = typeof window !== 'undefined' ? window.innerWidth : 1200;

  // Set initial column widths based on the fallback container width.
  const [columns, setColumns] = useState(
    initialColumns.map(col => ({
      ...col,
      width: Math.floor(initialContainerWidth * col.percentageWidth),
    }))
  );

  // Function to update column widths based on the measured container.
  const updateColumnWidths = useCallback(() => {
    if (tableContainerRef.current) {
      const containerWidth = tableContainerRef.current.offsetWidth;
      setColumns(initialColumns.map(col => ({
        ...col,
        width: Math.floor(containerWidth * col.percentageWidth),
      })));
    }
  }, [initialColumns]);

  // Use useLayoutEffect to update column widths as soon as the component is mounted.
  useLayoutEffect(() => {
    updateColumnWidths();
  }, [updateColumnWidths]);

  // Update widths on window resize.
  useEffect(() => {
    window.addEventListener('resize', updateColumnWidths);
    return () => window.removeEventListener('resize', updateColumnWidths);
  }, [updateColumnWidths]);


  const handleResize = useCallback(
    (index) => (e, { size }) => {
      setColumns((prevColumns) => {
        const newColumns = [...prevColumns];
        newColumns[index] = { ...newColumns[index], width: size.width };
        return newColumns;
      });
    },
    []
  );

  const mergedColumns = useMemo(
    () =>
      columns.map((col, index) => ({
        ...col,
        onHeaderCell: (column) => ({
          width: column.width,
          onResize: handleResize(index),
        }),
      })),
    [columns, handleResize]
  );

  // Stable progress percentage calculation that never decreases
  const progressPercent = useMemo(() => {
    if (!isLoading || totalCount === 0) {
      lastProgressRef.current = 0;
      return 0;
    }
    const calculated = Math.min(
      Math.round((loadedCount / totalCount) * 100),
      100
    );
    // Ensure progress never goes backwards and update ref
    const finalPercent = Math.max(calculated, lastProgressRef.current);
    lastProgressRef.current = finalPercent;
    return finalPercent;
  }, [isLoading, loadedCount, totalCount]);

  return (
    <Row>
      {contextHolder}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.6;
          }
        }
      `}</style>
      <Col md={24}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item href="/dashboard">
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            Document Management
          </Breadcrumb.Item>
          <Breadcrumb.Item>Accounts Receivable</Breadcrumb.Item>
        </Breadcrumb>
        <div className="border-container">
          <Button
            type="primary"
            variant="dashed"
            className="card-button"
            size="large"
            icon={<PlusOutlined />}
            onClick={upload}
            shape="circle"
          />
          <Card title="Accounts Receivable" bordered={true}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Form
                ref={formRef}
                layout="vertical"
                style={{
                  width: "75%",
                }}
              >
                <Row gutter={24}>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item
                      label="From Date"
                      validateStatus={errors.fromDate ? 'error' : ''} help={errors.fromDate || ''}
                      required
                    >
                      <DatePicker name="fromDate" //value={dayjs(payload["fromDate"])} 
                        onChange={onFromDateChange} value={dayjs(payload.fromDate)}
                        size="large" style={{ width: "100%" }} disabledDate={disabledFutureDate} format={dateFormat} />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item
                      label="To Date"
                      validateStatus={errors.toDate ? 'error' : ''} help={errors.toDate || ''}
                      required
                    >
                      <DatePicker name="toDate"
                        onChange={onToDateChange}
                        size="large" style={{ width: "100%" }} value={dayjs(payload.toDate)} disabledDate={disabledFutureDate} format={dateFormat} />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item
                      label="Document Type"
                    >
                      <Select 
                        mode="multiple"
                        name="documentType" 
                        options={documentType} 
                        value={payload["documentType"] || []} 
                        onChange={onDocumentTypeChange} 
                        size="large" 
                        placeholder="Select Multiple Document Types"
                        allowClear
                        maxTagCount="responsive"
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#f6ffed',
                                border: '1px solid #b7eb8f',
                                borderRadius: '8px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                                color: '#52c41a',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      >
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item

                      label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          Classification Code
                          <Popover content={popoverContentCla} title="Classification" trigger="hover">
                            <InfoCircleOutlined className="info-icon" />
                          </Popover>
                        </div>
                      }
                    >
                      
                      <Select
                        mode="multiple"
                        showSearch
                        size="large"
                        options={classification}   // label is string
                        value={payload["classification"] || []}
                        onChange={onClassificationChange}
                        name="classification"
                        placeholder="Select Multiple Classifications"
                        optionFilterProp="label"
                        allowClear
                        maxTagCount="responsive"
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        optionRender={(option) => (
                          <Tooltip title={option.data.description} color="orange">
                            <div
                              style={{
                                whiteSpace: 'normal',
                                lineHeight: '1.0em',
                                maxWidth: '100%',
                                overflowWrap: 'break-word',
                                fontSize: '14px',
                              }}
                            >
                              <strong>{option.data.code}</strong> - {truncateText(option.data.description)}
                            </div>
                          </Tooltip>
                        )}
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#fff7e6',
                                border: '1px solid #ffd591',
                                borderRadius: '8px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                                color: '#d46b08',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      />

                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Supplier Name" >
                      <Input size="large" name="supplierName"
                        value={payload["supplierName"]}
                        onChange={(e) => { setPayload(prev => ({ ...prev, supplierName: e.target.value })); }}
                        placeholder="Enter Supplier Name" />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Buyer Name" >
                      <Select
                        mode="tags"
                        size="large"
                        name="buyerName"
                        value={payload["buyerName"]}
                        onChange={(values) => { setPayload(prev => ({ ...prev, buyerName: values })); }}
                        placeholder="Enter Buyer Names"
                        style={{ width: '100%' }}
                        tokenSeparators={[',']}
                        allowClear
                        maxTagCount="responsive"
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#f0f0f0',
                                border: '1px solid #d9d9d9',
                                borderRadius: '8px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Invoice Number" >
                      <Select
                        mode="tags"
                        size="large"
                        name="invoiceNumber"
                        value={payload["invoiceNumber"]}
                        onChange={(values) => { setPayload(prev => ({ ...prev, invoiceNumber: values })); }}
                        placeholder="Enter Invoice Numbers"
                        style={{ width: '100%' }}
                        tokenSeparators={[',']}
                        allowClear
                        maxTagCount="responsive"
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#f0f0f0',
                                border: '1px solid #d9d9d9',
                                borderRadius: '8px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                    <Form.Item label="Company Code" >
                      <Select
                        mode="tags"
                        size="large"
                        name="companyCode"
                        value={payload["companyCode"]}
                        onChange={(values) => { setPayload(prev => ({ ...prev, companyCode: values })); }}
                        placeholder="Enter Company Codes"
                        style={{ width: '100%' }}
                        tokenSeparators={[',']}
                        allowClear
                        maxTagCount="responsive"
                        options={companyCodeOptions}
                        showSearch
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        tagRender={(props) => {
                          const { label, closable, onClose } = props;
                          return (
                            <span
                              style={{
                                background: '#f0f0f0',
                                border: '1px solid #d9d9d9',
                                borderRadius: '8px',
                                padding: '2px 8px',
                                margin: '2px',
                                display: 'inline-block',
                              }}
                            >
                              {label}
                              {closable && (
                                <span
                                  style={{
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    color: '#999',
                                  }}
                                  onClick={onClose}
                                >
                                  ×
                                </span>
                              )}
                            </span>
                          );
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={8} md={24} sm={24} xs={24}>
                  <Form.Item label="Status">
                    <Select
                      mode="multiple"
                      name="status"
                      showSearch                             // enable search
                      options={status}                       // make sure each option has { value, label }
                      value={payload["status"] || []}
                      onChange={onStatusChange}
                      size="large"
                      placeholder="Select Multiple Status"
                      listHeight={200}
                      maxTagCount="responsive"
                      allowClear
                      optionFilterProp="label"               // search uses label
                      filterOption={(input, option) =>
                        (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                      }                                      // case-insensitive search
                      optionRender={(option) => (            // optional: style dropdown items
                        <div style={{ whiteSpace: "normal", lineHeight: "1.2em", overflowWrap: "break-word" }}>
                          {option.data.label}
                        </div>
                      )}
                      tagRender={(props) => {
                        const { label, closable, onClose } = props;
                        return (
                          <span
                            style={{
                              background: '#e6f7ff',
                              border: '1px solid #91d5ff',
                              borderRadius: '10px',
                              padding: '2px 8px',
                              margin: '2px',
                              display: 'inline-block',
                              color: '#1890ff',
                            }}
                          >
                            {label}
                            {closable && (
                              <span
                                style={{
                                  marginLeft: '4px',
                                  cursor: 'pointer',
                                  color: '#999',
                                }}
                                onClick={onClose}
                              >
                                ×
                              </span>
                            )}
                          </span>
                        );
                      }}
                    />
                  </Form.Item>
                  </Col>
                </Row>
                <Row justify="center" gutter={16}>
                  <Col>
                    <Button size="large" onClick={handleFormClear}>
                      Clear
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      size="large"
                      type="primary"
                      onClick={() => handleFormSearch()}
                    >
                      Search
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
            <Divider />
            
            <div style={{ marginBottom: '16px' }}>
              <Alert
                message={`${selectedRows.length} Documents Selected (Click to Clear)`}
                type="info"
                showIcon
                style={{ 
                  width: 'fit-content', 
                  cursor: 'pointer'  //make it look clickable
                }}
                onClick={() => {
                  setSelectedRowKeys([]);   //clear selection keys
                  setSelectedRows([]);      //clear selection rows
                }}
              />
            </div>
            
            <Flex gap={14} align="center">
              {isLoading && totalCount > 0 && (
                <Flex gap={8} align="center">
                  <Progress
                    type="circle"
                    percent={progressPercent}
                    status="active"
                    strokeColor={{
                      '0%': '#108ee9',
                      '100%': '#87d068',
                    }}
                    size={40}
                    format={(percent) => `${percent}%`}
                  />
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    animation: 'pulse 1.5s ease-in-out infinite'
                  }}>
                    <Spin size="small" />
                    <span style={{ 
                      fontSize: '14px', 
                      color: '#1890ff',
                      fontWeight: 500
                    }}>
                      Invoices Loading...
                    </span>
                  </div>
                </Flex>
              )}
              <div style={{ display: 'flex', gap: '14px', marginLeft: 'auto' }}>
              <Tooltip
                title={
                  isLhdnSubmissionBlocked
                    ? "LHDN submission is disabled for this company. Contact your system administrator to enable LHDN submissions."
                    : !isSelectedRecordSubmittable
                    ? "Please select submittable records (extracted or failed submittable status)"
                    : ""
                }
                placement="top"
              >
                <Button onClick={showInvoiceDrawer}
                  disabled={!isSelectedRecordSubmittable || isLhdnSubmissionBlocked}>
                  <Space>
                    Submit
                  </Space>
                </Button>
              </Tooltip>
              <Button onClick={onCancelChange}
                disabled={!isCancelBtnDisable}>
                <Space>
                  Cancel
                </Space>
              </Button>
              <Tooltip 
                title={!isDeleteBtnDisable && deleteButtonDisableReason ? deleteButtonDisableReason : ''}
                placement="top"
              >
                <Button 
                  onClick={onDeleteChange}
                  disabled={!isDeleteBtnDisable}
                >
                  <Space>
                    Delete
                  </Space>
                </Button>
              </Tooltip>
              <Button onClick={() => shareDocumentDrawer(null)}
                disabled={!isShareBtnDisable}>
                <Space>
                  Share
                </Space>
              </Button>
              <Dropdown disabled={selectedRows.length === 0} menu={{ items: getMenuItems() }} className="download-btn">
                <Button>
                  <Space>
                    Download
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
              </div>
            </Flex>
            <br />
            <div
              style={{
                maxWidth: '100%', // Ensure the container doesn't exceed its width
                overflowX: 'auto', // Enable horizontal scroll
              }}
            >
              <Table
                components={{
                  header: {
                    cell: ResizableTitle,
                  },
                }}
                columns={mergedColumns}
                dataSource={accountReceivableSearchData}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No records found!' /> }}
                size="middle"
                rowSelection={{
                  selectedRowKeys,
                  onChange: handleSelectChange,
                  getCheckboxProps: (record) => ({
                    // Allow selection of any record - no restrictions based on status or flags
                    disabled: false
                  }),
                }}
              />
            </div>
          </Card>
        </div>
        <Create ref={createRef} />
        <InvoiceGeneration ref={invoiceRef} onClose={() => { refreshTableData(); }} />
        <ShareDocument selectedRecords={selectedRecordsUpdated} currentRecord={currentRecord} ref={shareDocumentRef} />
        <ViewDocument ref={viewDocumentRef} />
        {isStatusTrialOpen && (<StatusTrial ref={statusTrialRef} open={isStatusTrialOpen} record={statusTrialRecord} onClose={closeStatusTrailDrawer} />)}

      </Col>
      {/* Cancel modal */}
      <Modal
        title="Are you sure you want to cancel this document?"
        visible={isModalVisible}
        //onOk={handleOk}
        width={700}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" size="large" onClick={handleCancel}>
            Close
          </Button>,
          <Popconfirm
            title={`Out of ${selectedRecords.length} selected invoices, ${cancelConfirmedRecords?.cancelling?.length} invoices will be sent for cancellation. Do you want to proceed ?`}

            open={isPopconfirmVisible}
            onConfirm={() => handleOk()}
            onCancel={handleCancelPopConfirm}
            onOpenChange={setIsPopconfirmVisible}
            okText="Yes"
            cancelText="No"
            cancelButtonProps={{ disabled: cancelButtonDisabled }}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
          >
            <Button key="submit" size="large" type="primary" onClick={handleCancelInvoiceClick} disabled={!cancelReason.length > 0}>
              Yes, Cancel!
            </Button>
          </Popconfirm>
          ,
        ]}
      >

        <h4>Selected Documents</h4>
        <div
          style={{
            maxWidth: '100%', // Ensure the container doesn't exceed its width
            overflowX: 'auto', // Enable horizontal scroll
          }}
        >
          <Table
            dataSource={selectedRecords}
            columns={cancellationColumns}
            pagination={{ pageSize: 5, showSizeChanger: false, }}
            size="small"
            locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No records found!' /> }}
          />
        </div>
        <br />
        <Form layout="vertical">

          <Form.Item
            label="Select a Reason"
            name="subject"
            required
            rules={[
              { required: true, message: "Reason is required." },
            ]}
          >
            <Select
              size="large"
              style={{ width: 350 }}
              onChange={onChangeReason}
              placeholder="Select a Reason"
            >
              <Option value="Customer Request">Customer Request</Option>
              <Option value="System Issue">System Issue</Option>
              <Option value="Other">Other</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Remark"
            name="remark"
            dependencies={["reason"]}
            rules={[({ getFieldValue }) => ({
              validator(_, value) {
                // Apply validation only if "item1" is selected
                if (getFieldValue("reason") === "Other" && !value) {
                  return Promise.reject(new Error(`Remark is required for Selected Reason`));
                }
                return Promise.resolve();
              },
            }),]}
          >
            <Input.TextArea rows={4}
              onChange={onChangeRemark}
              placeholder="Enter your remark" />
          </Form.Item>
        </Form>
        {cancelResponceList.cancelSuccessList && (<Alert
          message="Cancel Success"
          description={`Following invoices cancelattion was successfull.${cancelResponceList.cancelSuccessList}`}
          type="success"
          showIcon />)}
        {cancelResponceList.cancelFailedList && (<Alert
          message="Error"
          description={`Following invoices cancelattion was Failed .${cancelResponceList.cancelFailedList}`}
          type="error"
          showIcon />)}
      </Modal>

      {/* Delete modal */}
      <Modal
        title="Are you sure you want to delete these invoices?"
        visible={isDeleteModalVisible}
        width={700}
        onCancel={handleDeleteCancel}
        footer={[
          <Button key="cancel" size="large" onClick={handleDeleteCancel}>
            Close
          </Button>,
          <Popconfirm
            title={`Out of ${selectedRecords.length} selected invoices, ${cancelConfirmedRecords?.deleting?.length || 0} invoices will be deleted. Do you want to proceed?`}
            open={isPopconfirmVisible}
            onConfirm={() => handleDeleteOk()}
            onCancel={handleDeletePopConfirm}
            onOpenChange={setIsPopconfirmVisible}
            okText="Yes"
            cancelText="No"
            cancelButtonProps={{ disabled: deleteButtonDisabled }}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
          >
            <Button key="submit" size="large" type="primary" danger onClick={handleDeleteInvoiceClick}>
              Yes, Delete!
            </Button>
          </Popconfirm>,
        ]}
      >
        <Alert
          message="Warning"
          description="Invoices with 'Pending', 'Submitted', or 'Success' status cannot be deleted. Only invoices with 'Extracted', 'Failed', 'Failed-Validation', 'Cancelled', or 'Failed Submitable' status can be deleted."
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
        
        <h4>Selected Invoices</h4>
        <div
          style={{
            maxWidth: '100%',
            overflowX: 'auto',
          }}
        >
          <Table
            dataSource={selectedRecords}
            columns={deletionColumns}
            pagination={{ pageSize: 5, showSizeChanger: false }}
            size="small"
            locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='No records found!' /> }}
          />
        </div>
      </Modal>
      {contextHolder}
    </Row>
  );
}
